import { render, staticRenderFns } from "./viewCalls.vue?vue&type=template&id=24517e4c&scoped=true"
import script from "./viewCalls.vue?vue&type=script&lang=js"
export * from "./viewCalls.vue?vue&type=script&lang=js"
import style0 from "./viewCalls.vue?vue&type=style&index=0&id=24517e4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24517e4c",
  null
  
)

export default component.exports